import dayjs from 'dayjs';

import { DateFormats } from 'utils/constants';

export type DateProps = {
  date: string | number;
  format?: DateFormats;
  className?: string;
};

function Date({ date, format = DateFormats.DATE, className }: DateProps) {
  return (
    <span data-testid="date" className={className}>
      {dayjs(date).format(format)}
    </span>
  );
}

export default Date;
